<mat-card class="envios-emergencia-avl-dialog">
  <app-card-header
    [title]="'Envíos de la emergencia AVL'"
    [subtitle]="data.nombreEntidad"
    icono="emergency_share"
    [botonAccion]="{ icon: 'refresh', tooltip: 'Actualizar' }"
    (accion)="cargar()"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <div class="eea-cuerpo">
      <div class="eea-datos">
        <span class="eea-etiqueta">Período</span>
        <span class="eea-valor">
          {{ data.config.periodoInicio | date: 'dd/MM/yyyy HH:mm' }}
          @if (data.config.periodoFin) {
            → {{ data.config.periodoFin | date: 'dd/MM/yyyy HH:mm' }}
          }
        </span>
        @if (envios.length) {
          <span class="eea-etiqueta">Resultado</span>
          <span class="eea-valor">
            {{ aceptados }} aceptados · {{ rechazados }} rechazados
            @if (hayMas) {
              <span class="eea-parcial">(de los cargados)</span>
            }
          </span>
        }
      </div>

      @if (!envios.length && cargando) {
        <mat-spinner diameter="28"></mat-spinner>
      } @else if (!envios.length) {
        <span class="no-info">No se registró ningún envío en el período.</span>
      } @else {
        <div class="eea-lista">
          @for (e of envios; track e._id) {
            <button
              type="button"
              class="eea-fila irx-sin-estilo"
              [class.eea-rechazado]="!e.ack"
              tooltip="Ver detalle"
              (click)="verDetalle(e)"
            >
              <mat-icon>{{ e.ack ? 'check_circle' : 'error' }}</mat-icon>
              <span class="eea-fecha">
                {{ e.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}
              </span>
              @if (e.respuestaStatus != null) {
                <span class="eea-http">HTTP {{ e.respuestaStatus }}</span>
              }
              <span class="eea-device">{{ deviceid(e) }}</span>
              <span class="eea-estado">
                {{ e.ack ? 'Aceptado' : e.error || 'Rechazado' }}
              </span>
            </button>
          }
        </div>
        @if (hayMas) {
          <button
            irxBoton="secundario"
            type="button"
            class="eea-mas"
            [disabled]="cargando"
            (click)="cargarMas()"
          >
            Cargar más
          </button>
        }
      }
    </div>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">Cerrar</button>
  </mat-card-actions>
</mat-card>
